import { createAsyncTypes } from "@client/redux/utils";

export const NAMESPACE = 'headerCampaigns';

export const ActionTypes = createAsyncTypes(NAMESPACE, ['FETCH_CAMPAIGNS']);

export interface CampaignForHeader {
    imageUrl?: string;
    name: string;
    campaignIdentifier: string;
}

export interface State {
    campaigns: CampaignForHeader[];
    isLoading: boolean;
    isError: boolean;
}
